var donut_chart = function()
{
	var instance = {};

	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].data = component.init_config;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		var config_data = scope[componentKey].data;
		
		//extend the component config with the result data
		$.extend( true, config_data, resultComponentVal.config );
		resultComponentVal.config = config_data;

		//reset component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};

        var tootltipObj = {
            "enabled": true,
            "useHTML": true,
            "borderColor": "#000",
            "backgroundColor": "#13161C",
            "style": {"color": "#fff", "opacity": ".8", "zIndex": "9999"},
            "borderWidth": 0,
            "animation": true,
            "borderRadius": "4",
            "formatter": function () {
                return "<span class='tooltip_container'>"+this.point.name+": "+this.point.y+"</span>";
            }
        };

        if(typeof resultComponentVal.config != 'undefined' &&
            resultComponentVal.config != null &&
            typeof resultComponentVal.config.options != 'undefined' &&
            typeof resultComponentVal.config.options.tooltip != 'undefined') {

            	resultComponentVal.config.options.tooltip = tootltipObj;
		}

        if(typeof resultComponentVal.config != 'undefined' &&
            resultComponentVal.config != null &&
            typeof resultComponentVal.config.series_color != 'undefined') {

            resultComponentVal.config.options.plotOptions.pie.colors = resultComponentVal.config.series_color;
        }

            //update component
		scope[componentKey].data = resultComponentVal.config;


	};

	return instance;
};
